import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left-v",
  "use": "icon-arrow-left-v-usage",
  "viewBox": "0 0 45 45",
  "content": "<symbol viewBox=\"0 0 45 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-left-v\">\n<path d=\"M17.6171 21.6452L24.5241 14.7382C24.9957 14.2666 25.7609 14.2666 26.2336 14.7382C26.7052 15.2098 26.7052 15.976 26.2336 16.4477L20.1814 22.4998L26.2336 28.552C26.7052 29.0236 26.7052 29.7899 26.2336 30.2615C25.7609 30.7331 24.9957 30.7331 24.5241 30.2615L17.6171 23.3545C17.1444 22.8829 17.1444 22.1166 17.6171 21.645V21.6452Z\" fill=\"#202020\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/arrow-left-v.svg
// module id = 97
// module chunks = 0 1 2